import * as React from "react";

import { ChatContext } from "./ChatContextTypes";

import type { ChatContextType } from "./ChatContextTypes";

// Custom hook to use the chat context
export const useChatContext = (): ChatContextType => {
  const context = React.useContext(ChatContext);
  if (context === undefined) {
    throw new Error("useChatContext must be used within a ChatProvider");
  }
  return context;
};
